module.exports = __webpack_public_path__ + "img/flex_screenshot_3.9cdb239f.png";